import InsightsHeader from './InsightsHeader'

export default InsightsHeader